import { Button, Card, CardActions, CardContent, Stack } from '@mui/material';
import React from 'react';
import PendingInvites from '../../Contractors/Clients/PendingInvites';
import JobRequests from '../../Contractors/Jobs/JobRequests';
import { NavigateNext } from '@mui/icons-material';
import { useNavigate } from 'react-router';

const ContractorComponents = () => {
    const navigate = useNavigate();
    return (
        <Stack spacing={2}>
            <Card>
                <CardContent>
                    <JobRequests />
                </CardContent>
                <CardActions>
                    <Button
                        endIcon={<NavigateNext />}
                        sx={{ ml: 'auto' }}
                        onClick={() => navigate('/jobs')}
                    >
                        See All Jobs
                    </Button>
                </CardActions>
            </Card>
            <Card>
                <CardContent>
                    <PendingInvites />
                </CardContent>
                <CardActions>
                    <Button
                        endIcon={<NavigateNext />}
                        sx={{ ml: 'auto' }}
                        onClick={() => navigate('/clients')}
                    >
                        See All Clients
                    </Button>
                </CardActions>
            </Card>
        </Stack>
    );
};

export default ContractorComponents;
